module.exports = __webpack_public_path__ + "static/media/mentor.1508c2cc.jpg";